import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Choose one of our available wallet providers or create a new one.", -1)

import { computed, type ComputedRef } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cta: ComputedRef<string> = computed((): string =>
  window?.ethereum
    ? `Please connect your wallet to use our marketplace.`
    : `You need an Ethereum wallet to use our marketplace.`
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_unref(cta)), 1),
    _hoisted_2
  ]))
}
}

})